<app-external-page [headerDescription]="clinicName" [schoolClinic]="schoolClinic">
    <div content-container>
        <router-outlet></router-outlet>
    </div>
</app-external-page>